import './components/app-root/app-root.js';
import './components/ui/flow-form/flow-form.js';
import './components/ui/flow-button/flow-button.js';
import './components/ui/flow-input/flow-input.js';
import './components/ui/flow-textarea/flow-textarea.js';
import './components/ui/flow-price/flow-price.js';
import './components/ui/flow-checkbox/flow-checkbox.js';
import './components/ui/flow-toast/flow-toast.js';
import './components/ui/flow-loader/flow-loader.js';
import './components/flow-panel/flow-panel.js';
import './components/auth-login/auth-login.js';

// En el futuro aquí podríamos inicializar configuraciones globales o temas

// TODO: Branch service: Detectar hubo cambios en logo, si no hubo edicion no volver a subirlo

console.info(process.env.VERSION)
